import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const Charges = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const intl = useIntl();
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  if (shipment?.totalCharges == null) {
    return '';
  }

  return <>{intl.formatNumber(shipment.totalCharges, { style: 'currency', currency: 'USD' })}</>;
};

export const charges = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.charges,
  name: <FormattedMessage {...ltlShipmentsGridMessages.charges} />,
  id: 'charges',
  width: 100,
  minWidth: 70,
  index: 7,
  render: (data: { id: string }) => <Charges freightShipmentId={data.id} />,
};
